import { Avatar, RegisteredUser, Room } from "../../proto/Global_pb";

export const ADD_AVATARS = "ADD_AVATARS";
export const REMOVE_AVATARS = "REMOVE_AVATARS";

export type AvatarsType = {
  [avatarId in Avatar.AsObject["id"]]: Avatar.AsObject;
};

export type RoomAvatarsType = {
  [key in Room.AsObject["id"] | RegisteredUser.AsObject["id"]]: Array<Avatar.AsObject["id"]>;
};

export type AvatarsStateType = {
  avatars: AvatarsType;
  roomAvatars: RoomAvatarsType;
};

export type AddAvatarsActionType = {
  type: typeof ADD_AVATARS;
  payload: {
    roomId: keyof RoomAvatarsType;
    avatars: Array<Avatar.AsObject>;
  };
};
export type RemoveAvatarsActionType = {
  type: typeof REMOVE_AVATARS;
  payload: {
    roomId: keyof RoomAvatarsType;
    avatarId: Avatar.AsObject["id"];
  };
};

export type AvatarsActionTypes = AddAvatarsActionType | RemoveAvatarsActionType;
